
import * as defaultImport from "lodash";
export * from "lodash";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
